/**
 * @file DataExtractors/CuratedPlaylist/index.js
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 */

import { setData } from "../../util";
import {
    VIDEO_CURATED_PLAYLIST_UPDATE,
    VIDEO_CURATED_PLAYLIST_NULL,
} from "../../../../actions/VideoCuratedPlaylist/constants";
import { hasVideoKeyInPayload } from "../../util";

export const initialState = setData();

export default function extractCuratedPlaylist(action) {
    switch (action.type) {
        case VIDEO_CURATED_PLAYLIST_UPDATE:
            if (!hasVideoKeyInPayload(action.payload, "curatedPlaylist"))
                return initialState;

            return setData(action.payload.video.data.curatedPlaylist);

        case VIDEO_CURATED_PLAYLIST_NULL:
            return initialState;

        default:
            return;
    }
}
